import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Banner from './img/banner.png';
import Qrs1 from './img/qrs1.png';
import Qrs2 from './img/qrs2.jpg';
import Qrs3 from './img/qrs3.jpg';
import Qrs4 from './img/qrs4.jpg';
import SmartFruitRobot from './img/智能果蔬采摘机器人.jpg';
import SmartMolecularDiagnosis from './img/智能高效分子光学诊断系统.jpg';
import SmartMolecularAnalysis from './img/智能生物分子分析系统.jpg';
import SmartPatrolRobot from './img/智能工业巡检机器人.jpg';
import SmartTrashCan from './img/移动智能垃圾桶.jpg';
import DualArmSystem from './img/双手臂互联协同系统.jpg';
import './PremiumProduct.css';

class ProductReduct extends Component {
    state = {}

    render() {
        // 项目数据
        const projects = [
            {
                id: 1,
                title: "智能避障小车",
                image: Qrs1,
                description: "通过安装在小车四周的超声波传感器反馈车辆与障碍物的距离，小车根据各种传感器数值判断车辆所遇到的环境，控制车辆前进后退避开障碍物。该项目培养了学生在嵌入式系统设计、传感器应用和自动控制方面的综合能力。"
            },
            {
                id: 2,
                title: "交互式智能机器人",
                image: Qrs2,
                description: "交互式机器人部件包括电池、电机、编码器、IMU、控制板、卡片电脑、RGBD 相机、激光雷达和转向舵机。可以用于ROS 多机通讯，OpenCV机器视觉，路径规划等实验和开发。该项目提升了学生在机器人操作系统和人工智能算法方面的实践技能。"
            },
            {
                id: 3,
                title: "智慧抓取系统",
                image: Qrs3,
                description: "系统以树莓派4B为主控，OpenCV为图像处理库，采用ROS机器人操作系统，内置MoveIt运动学，可实现物体识别、抓取、颜色追踪、码垛等多种功能。该项目锻炼了学生在计算机视觉和机械控制领域的综合应用能力。"
            },
            {
                id: 4,
                title: "智慧门禁系统",
                image: Qrs4,
                description: "集成人脸识别、红外体温识别、高温警告、门禁控制、健康码核验、数据实时上传等功能的门禁系统。能简化进出操作，能有效减少人员接触、节约排队时间，对助力后疫情时代的健康防控有一定的工程应用价值。该项目体现了学生在物联网和疫情防控技术方面的创新能力。"
            },
            {
                id: 5,
                title: "智能果蔬采摘机器人",
                image: SmartFruitRobot,
                description: "智能果蔬采摘机器人项目培养学生在机器人控制、图像识别和自动控制方面的综合能力。通过该系统，学生可以学习机械臂控制、路径规划、视觉识别等关键技术。"
            },
            {
                id: 6,
                title: "智能高效分子光学诊断系统",
                image: SmartMolecularDiagnosis,
                description: "该系统结合了光学技术和分子诊断技术，培养学生在精密光学仪器设计和生物医学工程方面的实践能力。学生通过该项目掌握光路设计、信号处理和系统集成等技能。"
            },
            {
                id: 7,
                title: "智能生物分子分析系统",
                image: SmartMolecularAnalysis,
                description: "智能生物分子分析系统项目涉及生物传感器、信号处理和数据分析技术。通过该项目，学生可以学习嵌入式系统在生物医学领域的应用，提升系统设计和工程实践能力。"
            },
            {
                id: 8,
                title: "智能工业巡检机器人",
                image: SmartPatrolRobot,
                description: "智能工业巡检机器人项目涵盖了移动机器人导航、传感器融合和远程监控技术。学生通过该系统学习嵌入式系统在工业自动化中的应用，培养系统集成和故障诊断能力。"
            },
            {
                id: 9,
                title: "移动智能垃圾桶",
                image: SmartTrashCan,
                description: "移动智能垃圾桶项目结合了物联网、传感器技术和自动控制技术。学生通过该项目学习智能设备的设计与开发，掌握环境感知、自主导航和人机交互等关键技术。"
            },
            {
                id: 10,
                title: "双手臂互联协同系统",
                image: DualArmSystem,
                description: "双手臂互联协同系统项目专注于多机器人协同控制技术。学生通过该系统学习多轴运动控制、协同算法和实时通信技术，提升在复杂控制系统设计方面的能力。"
            }
        ];

        return (
            <div className="premium-product" id="a">
                <div className="premium-product-container">
                    {projects.map(project => (
                        <Link to={`/project/${project.id}`} key={project.id} className="premium-product-card">
                            <div className="premium-product-image">
                                <img src={project.image} alt={project.title} />
                            </div>
                            <div className="premium-product-content">
                                <h3 className="premium-product-title">{project.title}</h3>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        );
    }
}

export default ProductReduct;